import React from 'react';
import Share from '../Share';

interface NeighborhoodHeaderProps {
  name: string;
  neighborhoodNameRef: React.RefObject<HTMLHeadingElement | null>;
}

export const NeighborhoodHeader: React.FC<NeighborhoodHeaderProps> = ({
  name,
  neighborhoodNameRef,
}) => (
  <section className="container mb-6 text-m lg:py-0 pt-10 md:pt-16">
    <div className="relative flex flex-col-reverse justify-between lg:flex-row">
      <div>
        <h1
          ref={neighborhoodNameRef}
          className="px-px py-1 pt-[10px] lg:pt-0 text-23-29-0.77 lg:text-30-47-1 uppercase font-sohneBreitBuch"
        >
          {name}
        </h1>
      </div>
      <div className="relative flex pt-px lg:pt-[6px] mb-2 space-x-2 text-16-26-0.3 lg:right-0 lg:-top-2 lg:relative">
        <div className="mt-0.5 md:w-full md:mt-2">
          <Share visibility="block" />
        </div>
      </div>
    </div>
  </section>
);
